import { DictUtil } from 'jczh-ui'

// 招标方式字典
export const bidMethodDict = new DictUtil({
  PUBLIC_BIDDING: { label: '公开招标', value: 1 },
  INVITE_BIDDING: { label: '邀请招标', value: 2 },
  COMPETITIVE_CONSULT: { label: '竞争性磋商', value: 3 },
  COMPETITIVE_NEGOTIATION: { label: '竞争性谈判', value: 4 },
  INQUIRY: { label: '询价', value: 5 },
  SINGLE_SOURCE: { label: '单一来源', value: 6 },
  INQUIRY_PURCHASE: { label: '询比', value: 7 },
  COMPETE_PURCHASE: { label: '竞价', value: 8 },
  NEGOTIATION_PURCHASE: { label: '谈判', value: 9 },
  OTHER: { label: '其他', value: -1 }
})
